import { Form, Offcanvas } from "react-bootstrap";
import { useForm } from "react-hook-form";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";

interface AddPlanProps {
    show: boolean;
    handleClose: () => void;
    data?: any;
}

type FormData = {
    planName: string;
    amount: string;
}

const AddPlan = ({ show, handleClose, data }: AddPlanProps) => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm<FormData>();
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if (data) {
            reset({
                planName: data.planName,
                amount: data.amount,
            });
        }
    }, [data])

    const onSubmit = (request: FormData) => {
        setLoading(true);
        const apiCall = data && data._id
            ? WebService.putAPI({
                action: `plan/edit-plan/${data._id}`,
                body: request,
            })
            : WebService.postAPI({
                action: `plan/add-plan`,
                body: request,
            });
        apiCall
            .then((res: any) => {
                setLoading(false);
                handleClose();
                reset();
                toast.success(res.message || 'Plan added successfully');
            })
            .catch((err: any) => {
                setLoading(false);
                toast.error(err.message || 'Something went wrong');
            })
    }

    return (
        <>
            <Offcanvas show={show} onHide={() => {
                handleClose();
                reset({
                    planName: '',
                    amount: '',
                });
            }}
                placement="end"
                className="offcanvas-custom">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{data ? 'Edit' : 'Add'}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form>
                        <Form.Group className="mb-2" controlId="planName">
                            <Form.Label className="label">Plan Name</Form.Label>
                            <Form.Control type="text" placeholder="Enter plan name"
                                {...register("planName", { required: 'Plan Name is required' })} />
                            {errors.planName && <div className="error-message">{errors.planName.message}</div>}
                        </Form.Group>
                        <Form.Group className="mb-2" controlId="amount">
                            <Form.Label className="label">Amount</Form.Label>
                            <Form.Control type="text" placeholder="Enter amount"
                                {...register("amount", { required: 'Amount is required' })} />
                            {errors.amount && <div className="error-message">{errors.amount.message}</div>}
                        </Form.Group>
                    </Form>
                </Offcanvas.Body>
                <div className="d-flex justify-content-end p-3">
                    <CustomButton
                        isLoading={isLoading}
                        label="Save"
                        className="w-100"
                        onClick={handleSubmit(onSubmit)}
                    />
                </div>
            </Offcanvas>
        </>
    )
}

export default AddPlan;